import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';
 
import { ProfileModel } from '../models/profile.model';
import { DataService } from '../services/data/data.service';
 
@Injectable({
  providedIn: 'root',
})

export class AdministratorsResolverService implements Resolve<ProfileModel[]> {

  constructor(private dataService: DataService) {
  }
 
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ProfileModel[]> | Observable<never> {
    let id = route.paramMap.get('profileId');
    const role = route.data.role;
    console.log('admin resolver', id, role);
    return this.dataService.getMyAdministrators(id,role).pipe(
        take(1),
        mergeMap(item => {
          if (item) {
            return of(item);
          } else { // id not found
            return EMPTY;
          }
        })
      );
  }
}